import React, { useState, useEffect, useRef, useMemo } from "react";
import { Link as RouterLink } from 'react-router-dom';
import {
  Checkbox,
  Button,
  Card,
  Container,
  FormControl,
  Autocomplete,
  TextField,
  Grid,
  Box,
  MenuItem,
  Select,
  InputLabel,
  Stack,
  Typography,
  Breadcrumbs,
  Link,
  createFilterOptions,
  ListItemText,
  Fab
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import Page from "../components/Page";
import DashboardBreadcrumbLink from 'src/components/DashboardBreadcrumbLink';
import { getClientCameras } from 'src/api/clientDetails';

import {
  getCamerasList_Live,
  getGroupsByClient,
  getCamerasByGroupID,
  getCamerasList,
  getClientGroupInfo,
} from "src/api/liveCameras";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import { getClientList } from "src/api/analytics";
import { VpnLockSharp } from "@mui/icons-material";
import DashboardNavbar from "src/layouts/dashboard/DashboardNavbar";
import { getClientLocations, getClientProperties } from 'src/api/ShiftMaster';
import { generateStreamURL } from 'src/utils/config';
import { jsonToParam } from 'src/utils/config';
import { useTheme, alpha } from '@mui/material/styles';
import { ClientList } from "src/sections/client";
import { getAppStorageItem } from 'src/utils/storageProxy';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const groupicon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const groupcheckedIcon = <CheckBoxIcon fontSize="small" />;

const getAssignedLocationsFromStorage = () => {
  try {
    const assignedLocationsRaw = getAppStorageItem('assigned_locations');
    if (!assignedLocationsRaw) return [];

    const parsedAssignedLocations = JSON.parse(assignedLocationsRaw);
    const assignedLocations = Array.isArray(parsedAssignedLocations)
      ? parsedAssignedLocations
      : [];

    return assignedLocations
      .map((locationItem) => ({
        ID: Number(locationItem?.ID ?? locationItem?.id ?? 0),
        Location: String(locationItem?.Location || locationItem?.name || '').trim(),
      }))
      .filter((locationItem) => locationItem.ID > 0);
  } catch (error) {
    console.error('Failed to read assigned_locations from storage:', error);
    return [];
  }
};

export default function LiveCameras({isReseller}) {
  const theme = useTheme();
  const resellerClientType = (localStorage.getItem('client_type') || '').toUpperCase();
  const isDark = theme.palette.mode === 'dark';
  const UI = {
    inputBg: isDark ? alpha(theme.palette.common.white, 0.06) : theme.palette.background.paper,
    inputText: theme.palette.text.primary,
    inputMuted: theme.palette.text.secondary,
    border: alpha(theme.palette.text.primary, isDark ? 0.26 : 0.18),
    borderHover: alpha(theme.palette.text.primary, isDark ? 0.44 : 0.28),
    cardBg: isDark ? '#1a2638' : theme.palette.background.paper,
    cardBorder: isDark ? alpha(theme.palette.common.white, 0.08) : alpha(theme.palette.text.primary, 0.16),
    shadow: isDark ? '0 8px 24px rgba(0, 0, 0, 0.28)' : '0 1px 3px rgba(0,0,0,0.08)',
  };
  const agentBased = localStorage.getItem('IsAgentBased');
  const Type = localStorage.getItem('Type');
  const [selectedGroup, setSelectedGroup] = useState("");
  const [selectedCameras, setSelectedCameras] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [liveCamerasList, setLiveCamerasList] = useState([]);
  const [clientGroupList, setClientGroupsList] = useState([]);
  const [camerasByGroupId, setCamerasByGroup] = useState([]);
  const [camerawithoutGroups, setCameraListWithoutGroups] = useState([]);
  const [filteredCamerawithoutGroups, setFilteredCameraListWithoutGroups] = useState([]);
  const [showOptions, setShowOptions] = useState(true);
  const [gridLayout, setGridLayout] = useState({ xs: 12 });
  const [errorMessage, setErrorMessage] = useState('');
  const [checkValue, setCheckValue] = useState(false);
  const [groupCheckValue, setGroupCheckValue] = useState(false);
  const [openAuto, setOpenAuto] = useState(false);
  const [activeCameras, setActiveCameras] = useState([]);
  const [inputValue, setInputValue] = useState([]);
  const [activeGroups, setActiveGroups] = useState([]);
  const [outerBoxWidth, setOuterBoxWidth] = useState('');
  const [outerBoxHeight, setOuterBoxHeight] = useState('');
  const [cameWidth, setCamewidth] = useState('');
  const [cameHeight, setCameHeight] = useState('');
  const [xsCount, setXSCountVal] = useState(null);
  const [clientList, setClientList] = useState([]);
  const [clientName, selectedClientName] = useState([]);
  const [saveError, setSaveError] = useState(false);
  const [isClientSelected, setIsClientSelected] = useState(false);
  const [isClient, setIsClient] = useState('');
  const [totalCameras, setTotalCameras] = useState([]);
  const [selectedClient, setSelectedClient] = useState('');
  const [errorGroup, setErrorGroup] = useState(null);
  const [client, setClient] = useState('');
  const [clientType, setClientType] = useState('');
  const [clientTypeerror, setClientTypeError] = useState('');
  const [setTypeClient, setSelectedTypeClient] = useState([]);
  const [groupinfo, setGroupinfo] = useState([]);
  const [clientLocationOptions, setClientLocationOptions] = useState([]);
  const [selectedClientLocations, setSelectedClientLocations] = useState([]);
  const [locationCheckValue, setLocationCheckValue] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [showGrid, setShowGrid] = useState(false);
  const [gridAreaHeight, setGridAreaHeight] = useState(null);
  const [viewportHeight, setViewportHeight] = useState(
    typeof window !== "undefined" ? window.innerHeight : 900
  );

  

  const storedProperty = localStorage.getItem('Location');
  const AssignClient = localStorage.getItem('AssignClient');
  const userType = localStorage.getItem('user_type');

  const [location, setLocation] = useState(() => {
    const stored = localStorage.getItem('selectedLocation');
    return stored ? parseInt(stored) : null;
  });
  const [locations, setLocations] = useState([]);

  const [property, setProperty] = useState(() => {
    
    const stored = localStorage.getItem('selectedProperty');
    return stored ? parseInt(stored) : null;
  });
  const [properties, setProperties] = useState([]);


  let client_id = 0;
  if(localStorage.getItem('Type') === 'merge'){
    client_id = localStorage.getItem('ID');
  }
  else{
    client_id = localStorage.getItem('client_id');
  }

  // Ref to track if we've already triggered the submit
  const hasTriggeredSubmit = useRef(false);
  const previousActiveGroupsRef = useRef([]);
  const propertyRequestRef = useRef(0);

  const normalizeDisplayName = (name) =>
    String(name || '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();

  const buildUniqueClientOptions = (clients) => {
    const grouped = new Map();

    (clients || []).forEach((clientItem) => {
      const key = normalizeDisplayName(clientItem?.displayname);
      if (!key) return;

      if (!grouped.has(key)) {
        grouped.set(key, []);
      }
      grouped.get(key).push(clientItem);
    });

    return Array.from(grouped.values()).map((groupItems) => {
      if (groupItems.length === 1) return groupItems[0];

      const assignTargets = new Set(
        groupItems
          .map((item) => Number(item.AssignClient || 0))
          .filter((assignId) => assignId > 0)
      );

      const mappedMain = groupItems.find((item) => assignTargets.has(Number(item.ID)));
      if (mappedMain) return mappedMain;

      const rootEntry = groupItems.find((item) => Number(item.AssignClient || 0) === 0);
      return rootEntry || groupItems[0];
    });
  };

  const uniqueClientOptions = useMemo(
    () => buildUniqueClientOptions(setTypeClient),
    [setTypeClient]
  );

  useEffect(() => {
    if(AssignClient!=='' && storedProperty!=='') {
      const assignedLocations = getAssignedLocationsFromStorage();
      setProperties(assignedLocations);

      const stored = localStorage.getItem('selectedProperty');
      if (stored) {
        const found = assignedLocations.find((loc) => loc.ID === parseInt(stored));
        if (found) {
          setProperty(found.ID);
        }
      } else {
        const first = assignedLocations[0];
        if (first) {
          setProperty(first.ID);
          localStorage.setItem('selectedProperty', first.ID);
        }
      }
    }

    const locationBody = {client_id: Number(client_id)}

    getClientLocations(locationBody, (response) => {

      if (response.status === 200) {

        setLocations(response.data);

        const stored = localStorage.getItem('selectedLocation');
        if (stored) {
          const found = response.data.find((loc) => loc.Id === parseInt(stored));
          if (found) {
            setLocation(found.Id);
          }
        } else {
          const first = response.data[0];
          if (first) {
            setLocation(first.Id);
            localStorage.setItem('selectedLocation', first.Id);
          }
        }
      }
    });

  }, []);

  const changeProperty = (value) => {
    propertyRequestRef.current += 1;
    setLiveCamerasList([]);
    setClientGroupsList([]);
    setGroupinfo([]);
    setCamerasByGroup([]);
    setCameraListWithoutGroups([]);
    setFilteredCameraListWithoutGroups([]);
    setActiveGroups([]);
    setActiveCameras([]);
    setInputValue([]);
    setCheckValue(false);
    setGroupCheckValue(false);
    setSubmitted(false);
    setIsInitialLoad(true);
    hasTriggeredSubmit.current = false;
    setProperty(value);
  }

  const getCameraLocationId = (camera) =>
    Number(
      camera?.clientid ??
      0
    );

  const getCameraClientId = (camera) =>
    Number(camera?.clientid ?? camera?.client_id ?? camera?.ClientId ?? 0);

  const filterCamerasForSelectedLocation = (cameras, selectedLocation = location) => {
    if (!(userType === '2' && client_id === "1316")) {
      return cameras || [];
    }

    const normalizedLocationId = Number(selectedLocation);
    if (!normalizedLocationId) {
      return cameras || [];
    }

    return (cameras || []).filter(
      (camera) => Number(camera?.LocationId ?? camera?.locationId ?? 0) === normalizedLocationId
    );
  };

  const getInitialDistributedCameras = (cameras, selectedLocationIds = [], limit = 6) => {
    const normalizedLocationIds = (selectedLocationIds || [])
      .map((locationId) => Number(locationId))
      .filter((locationId) => locationId > 0);

    if (normalizedLocationIds.length <= 1) {
      return (cameras || []).slice(0, limit);
    }

    const buckets = new Map();
    normalizedLocationIds.forEach((locationId) => {
      buckets.set(locationId, []);
    });

    (cameras || []).forEach((camera) => {
      const locationId = getCameraLocationId(camera);
      if (buckets.has(locationId)) {
        buckets.get(locationId).push(camera);
      }
    });

    const orderedCameras = [];
    let addedInPass = true;

    while (orderedCameras.length < limit && addedInPass) {
      addedInPass = false;

      normalizedLocationIds.forEach((locationId) => {
        if (orderedCameras.length >= limit) return;

        const locationBucket = buckets.get(locationId) || [];
        if (locationBucket.length > 0) {
          orderedCameras.push(locationBucket.shift());
          addedInPass = true;
        }
      });
    }

    if (orderedCameras.length < limit) {
      const selectedIds = new Set(orderedCameras.map((camera) => camera.deviceid));
      const remainingCameras = (cameras || []).filter((camera) => !selectedIds.has(camera.deviceid));
      orderedCameras.push(...remainingCameras.slice(0, limit - orderedCameras.length));
    }

    return orderedCameras;
  };

  const getInitialGroupSelection = (groupRows = [], uniqueGroups = [], limit = 6) => {
    if (!Array.isArray(uniqueGroups) || uniqueGroups.length === 0) return [];

    const groupToDevices = new Map();

    (groupRows || []).forEach((row) => {
      const groupId = Number(row?.GroupId);
      if (!groupId) return;

      const deviceId =
        row?.deviceid ??
        row?.DeviceId ??
        row?.cameraid ??
        row?.CameraId;

      if (!groupToDevices.has(groupId)) {
        groupToDevices.set(groupId, new Set());
      }

      groupToDevices.get(groupId).add(deviceId ?? `row-${groupId}-${groupToDevices.get(groupId).size}`);
    });

    const selectedGroupIds = [];
    let selectedCameraCount = 0;

    for (const group of uniqueGroups) {
      const groupId = Number(group?.GroupId);
      if (!groupId) continue;

      selectedGroupIds.push(groupId);
      selectedCameraCount += (groupToDevices.get(groupId) || new Set()).size;

      if (selectedCameraCount >= limit) {
        break;
      }
    }

    return selectedGroupIds.length > 0 ? selectedGroupIds : [Number(uniqueGroups[0].GroupId)];
  };

  const loadGroupsAndCameras = (selectedClientId, selectedLocationIds = []) => {
    
    const selectedLocationIdNumbers = (selectedLocationIds || [])
      .map((locationId) => Number(locationId))
      .filter((locationId) => locationId > 0);

    const targetClientIdForGroups = selectedLocationIdNumbers.length > 0
      ? selectedLocationIdNumbers.join(',')
      : selectedClientId;

    let body = { clientId: targetClientIdForGroups, groupId: 0 };

    getClientGroupInfo(body, (response) => {
      if (response.status === 200 && response.data.length > 0) {
        setGroupinfo(response.data);
        const uniqueGroups = Array.from(
          new Map(response.data.map(item => [item.GroupId, { GroupId: item.GroupId, GroupName: item.GroupName }])).values()
        );
        setClientGroupsList(uniqueGroups);
        setCameraListWithoutGroups([]);
        setFilteredCameraListWithoutGroups([]);
        return;
      }

      setGroupinfo([]);
      setClientGroupsList([]);
      setCamerasByGroup([]);

      const sourceCameras = totalCameras || [];
      const fallbackCameras = selectedLocationIdNumbers.length > 0
        ? sourceCameras.filter((camera) => selectedLocationIdNumbers.includes(getCameraLocationId(camera)))
        : sourceCameras.filter((camera) => getCameraClientId(camera) === Number(selectedClientId));

      setCameraListWithoutGroups(fallbackCameras);
      setFilteredCameraListWithoutGroups(fallbackCameras);
    });
  };

  const handleLocationFilterOptions = (options, params) => {
    const filtered = options.filter((option) =>
      (option?.Location || '').toLowerCase().includes(params.inputValue.toLowerCase())
    );

    return [{ title: 'Select All', selectall: true }, ...filtered];
  };

  const handleClientLocationChange = (event, value) => {
    if (!selectedClient?.ID) return;

    let nextSelectedLocations = [];

    if (value.some((option) => option.selectall)) {
      nextSelectedLocations = locationCheckValue ? [] : clientLocationOptions.map((location) => location.ID || location.id);
    } else {
      nextSelectedLocations = value.map((location) => location.ID || location.id);
    }

    setSelectedClientLocations(nextSelectedLocations);
    setLocationCheckValue(
      clientLocationOptions.length > 0 && nextSelectedLocations.length === clientLocationOptions.length
    );
    setActiveGroups([]);
    setGroupCheckValue(false);
    setActiveCameras([]);
    setInputValue([]);
    setCheckValue(false);

    if (clientLocationOptions.length > 0 && nextSelectedLocations.length === 0) {
      setGroupinfo([]);
      setClientGroupsList([]);
      setCamerasByGroup([]);
      setCameraListWithoutGroups([]);
      setFilteredCameraListWithoutGroups([]);
      return;
    }

    loadGroupsAndCameras(selectedClient.ID, nextSelectedLocations);
  };

  const handleClient = (_, value) => {
    setClientGroupsList([]);
    setCameraListWithoutGroups([]);
    setFilteredCameraListWithoutGroups([]);
    setCamerasByGroup([]);
    setLiveCamerasList([]);
    setClientLocationOptions([]);
    setSelectedClientLocations([]);
    setLocationCheckValue(false);
    setActiveGroups([]);
    setGroupCheckValue(false);
    setActiveCameras([]);
    setInputValue([]);

    if (value) {
      if (checkValue) {
        setCheckValue(!checkValue);
      }
      let clientId = value.ID;
      setClient(clientId);

      getClientProperties({ AssignClient: String(clientId) }, (response) => {
        if (response.status === 200) {
          const normalizedLocations = Array.from(
            new Map(
              (Array.isArray(response.data) ? response.data : (response.data ? [response.data] : []))
                .map((locationItem) => ({
                  ...locationItem,
                  ID: Number(locationItem?.ID ?? locationItem?.id ?? 0),
                  Location: (locationItem?.Location || locationItem?.name || '').trim()
                }))
                .filter((locationItem) => locationItem.ID > 0)
                .map((locationItem) => [locationItem.ID, locationItem])
            ).values()
          );

          setClientLocationOptions(normalizedLocations);

          if (normalizedLocations.length === 1) {
            const singleLocationId = normalizedLocations[0].ID || normalizedLocations[0].id;
            setSelectedClientLocations([singleLocationId]);
            setLocationCheckValue(true);
            loadGroupsAndCameras(clientId, [singleLocationId]);
            return;
          }

          if (normalizedLocations.length > 1) {
            setSelectedClientLocations([]);
            setLocationCheckValue(false);
            return;
          }
        }

        setClientLocationOptions([]);
        setSelectedClientLocations([]);
        setLocationCheckValue(false);
        loadGroupsAndCameras(clientId, []);
      });
    } else {
      setClient('');
      setClientLocationOptions([]);
      setSelectedClientLocations([]);
      setLocationCheckValue(false);
    }
  };

  useEffect(() => {
    if (userType === "2") {
      setIsClient(true);
    } else {
      setIsClient(false);
      getClientList((response) => {
        if (response.status === 200) {
          setClientList(response.data);
        }
      });
    }
  }, []);


  useEffect(()=>{  
    const requestId = ++propertyRequestRef.current;

     if (userType === "2") {
      let clientId = property !== null ? property : client_id;
      let groupId = 0;
      let body = { clientId: clientId, groupId: groupId };
      getClientGroupInfo(body, (response) => {
        if (requestId !== propertyRequestRef.current) return;

        if (response.status === 200 && response.data.length > 0) {
          setLiveCamerasList([]);
          setGroupinfo(response.data);
          const uniqueGroups = Array.from(
            new Map(response.data.map(item => [item.GroupId, { GroupId: item.GroupId, GroupName: item.GroupName }])).values()
          );
          setClientGroupsList(uniqueGroups);

          if (uniqueGroups.length > 0 && isInitialLoad) {
            const initialGroups = getInitialGroupSelection(response.data, uniqueGroups, 6);
            setActiveGroups(initialGroups);
          }
      }
      else {
        getClientCamerasList(property, requestId);
      }
      });
    } else {
    getClientCamerasList(property, requestId);
    }
  },[property])

  const getClientCamerasList = (selectedProperty = property, requestId = propertyRequestRef.current) => {
    let bodyParams = {};
    if(userType === "2") {
      if (!['share', 'sub', 'merge'].includes(Type)) {
        bodyParams.status = '0,1';
        if (selectedProperty !== null) {
          bodyParams.property_id = Number(selectedProperty);
        } else {
          bodyParams.clientid = Number(client_id);
        } 
      }
    }

    setClientGroupsList([]);
    //setCameraListWithoutGroups([]);
    setCamerasByGroup([]);
    setLiveCamerasList([]);
    setActiveCameras([]);

    bodyParams = jsonToParam(bodyParams);

    console.log('devices params:',JSON.stringify(bodyParams))

    getClientCameras(bodyParams, (response) => {
      if (requestId !== propertyRequestRef.current) return;

      if (response.status === 200) {
        if (response.data !== null) {
          if (userType === '2') {

            const propertyCameras = selectedProperty !== null
              ? response.data.filter(
                  (camera) => getCameraClientId(camera) === Number(selectedProperty)
                )
              : response.data;

            setCameraListWithoutGroups(propertyCameras);
          } else {
            setTotalCameras(response.data);
          }
        }
      }
    });
  }
  
  useEffect(() => {
    
    setGroupinfo([]);
    setClientGroupsList([]);
    setCheckValue(false);
    setActiveCameras([]);
    setCamerasByGroup([]);
    setCameraListWithoutGroups([]);
    setFilteredCameraListWithoutGroups([]);
    setSelectedClient(null);
    setClientLocationOptions([]);
    setSelectedClientLocations([]);
    setLocationCheckValue(false);
    setLiveCamerasList([]);

    const effectiveClientType = isReseller
      ? (resellerClientType === "INDIA" ? "INDIA" : "US")
      : clientType;

    if (effectiveClientType === "INDIA") {
      const indiaClients = clientList.filter((row) => row.ClientType === 'INDIA' && row.EnvironmentType !==0);
      const sortedData = [...indiaClients].sort((a, b) =>
        a.displayname.trim().localeCompare(b.displayname.trim())
      );
      setSelectedTypeClient(sortedData);
    } else if (effectiveClientType === "US") {
      const usClients = clientList.filter((row) => row.ClientType === 'US' && row.EnvironmentType !==0);
      const sortedData = [...usClients].sort((a, b) =>
        a.displayname.trim().localeCompare(b.displayname.trim())
      );
      setSelectedTypeClient(sortedData);
    }
  }, [clientType, clientList, isReseller, resellerClientType]);

  useEffect(() => {
    
    if (activeGroups.length > 0) {
      const cameras = filterCamerasForSelectedLocation(
        groupinfo.filter((val) => activeGroups.includes(val.GroupId))
      );
      setCamerasByGroup(cameras);

      const firstCameras = getInitialDistributedCameras(cameras, selectedClientLocations, 6);

      if (isInitialLoad && activeCameras.length === 0 && cameras.length > 0) {
        const firstDeviceIds = firstCameras.map(val => val.deviceid);
        setActiveCameras(firstDeviceIds);
        setInputValue(firstCameras);
        setIsInitialLoad(false);
      } else {
        const newId = cameras.map(val => val.deviceid);
        const filArr = activeCameras.filter(val => newId.includes(val));
        setActiveCameras(filArr);
        if (cameras.length === filArr.length && filArr.length > 0) {
          setCheckValue(true);
        }
      }
    }
  }, [activeGroups, groupinfo, location]);

  useEffect(() => {
    if (userType !== '2' || client_id !== "1316") return;

    const nextFilteredCameras = filterCamerasForSelectedLocation(camerawithoutGroups);
    setFilteredCameraListWithoutGroups(nextFilteredCameras);
  }, [camerawithoutGroups, location]);

  useEffect(() => {
    if (!client || clientGroupList.length > 0) return;

    if (clientLocationOptions.length > 0) {
      const locationIds = selectedClientLocations
        .map((locationId) => Number(locationId))
        .filter((locationId) => locationId > 0);

      if (locationIds.length === 0) {
        setCameraListWithoutGroups([]);
        setFilteredCameraListWithoutGroups([]);
        return;
      }

      const locationCameras = (totalCameras || []).filter((camera) =>
        locationIds.includes(getCameraLocationId(camera))
      );
      setCameraListWithoutGroups(locationCameras);
      setFilteredCameraListWithoutGroups(locationCameras);
      return;
    }

    const clientCameras = (totalCameras || []).filter((camera) => getCameraClientId(camera) === Number(client));
    setCameraListWithoutGroups(clientCameras);
    setFilteredCameraListWithoutGroups(clientCameras);
  }, [client, clientGroupList, totalCameras, clientLocationOptions, selectedClientLocations]);

  useEffect(() => {
    if (camerawithoutGroups.length > 0 && isInitialLoad && activeCameras.length === 0) {
      getCamerasSelectedList(camerawithoutGroups, location);
    }
  }, [camerawithoutGroups]);

  // New useEffect to trigger handleSubmit after activeCameras is updated
  useEffect(() => {
    if (isInitialLoad === false && activeCameras.length > 0 && !hasTriggeredSubmit.current) {
      hasTriggeredSubmit.current = true;
      handleSubmit();
    }
  }, [activeCameras, isInitialLoad]);
  
  const changeLocation = (value) => {
    setLocation(value);
    setCheckValue(false);
    setInputValue([]);
    setActiveCameras([]);
    hasTriggeredSubmit.current = false;
    getCamerasSelectedList(camerawithoutGroups, value);
  }

  const getCamerasSelectedList = (camerawithoutGroups, location) => {
    
    console.log('camerawithoutGroups:', camerawithoutGroups);
    console.log('location:', location);
      const filteredCameras = filterCamerasForSelectedLocation(camerawithoutGroups, location);

      if(client_id === "1316") {
        setFilteredCameraListWithoutGroups(filteredCameras);
      } 

      const preferredLocationIds = selectedClientLocations.length > 0 ? selectedClientLocations : [location];
      const firstCameras = getInitialDistributedCameras(filteredCameras, preferredLocationIds, 6);
      const firstDeviceIds = firstCameras.map(camera => camera.deviceid);
      setActiveCameras(firstDeviceIds);
      setInputValue(firstCameras);
      setIsInitialLoad(false);
  }


  useEffect(() => {
    if (activeGroups.length === clientGroupList.length && activeGroups.length > 0) {
      setGroupCheckValue(true);
    }
  }, [activeGroups, clientGroupList]);

  useEffect(() => {
    const previousGroups = previousActiveGroupsRef.current || [];
    const hasChanged =
      previousGroups.length !== activeGroups.length ||
      previousGroups.some((groupId, index) => groupId !== activeGroups[index]);

    if (hasChanged) {
      setLiveCamerasList([]);
      setSubmitted(false);
    }

    previousActiveGroupsRef.current = [...activeGroups];
  }, [activeGroups]);

  useEffect(() => {
    const count = liveCamerasList.length;
    const shouldFitViewport = showGrid && count > 0 && count <= 20;
    const headerHeight = shouldFitViewport ? 100 : (showGrid ? 80 : 200);
    const availableHeight = Math.max(viewportHeight - headerHeight, 320);
  
    let rows = 1;
    let xs = 4;
  
    if (count <= 1) {
      rows = 1;
      xs = 12;
    } else if (count === 2) {
      rows = 1;
      xs = 6;
    } else if (count === 3) {
      rows = 1;
      xs = 4;
    } else if (count === 4) {
      rows = 2;
      xs = 6;
    } else if (count >= 5 && count <= 6) {
      rows = 2;
      xs = 4;
    } else if (count >= 7 && count <= 9) {
      rows = 3;
      xs = 4;
    } else if (count >= 10 && count <= 12) {
      rows = 3;
      xs = 3;
    } else if (count >= 13 && count <= 16) {
      rows = 4;
      xs = 3;
    } else if (count >= 17) {
      rows = Math.ceil(count / 5);
      xs = 2.4;
    } else {
      rows = Math.ceil(count / 4);
      xs = 3;
    }
  
    const rowGap = shouldFitViewport ? 16 : 0;
    const totalRowGaps = Math.max(rows - 1, 0) * rowGap;
    const usableHeight = Math.max(availableHeight - totalRowGaps, 220);
    const cardHeight = Math.max(Math.floor(usableHeight / rows), shouldFitViewport ? 120 : 220);
    const iframeHeight = cardHeight;
  
    setOuterBoxHeight(`${cardHeight}px`);
    setCameHeight(`${iframeHeight}px`);
    setXSCountVal(xs);
    setOuterBoxWidth('100%');
    setCamewidth('100%');
    setGridAreaHeight(shouldFitViewport ? availableHeight : null);
  }, [liveCamerasList, showGrid, viewportHeight]);
  
  useEffect(() => {
    const handleResize = () => {
      setViewportHeight(window.innerHeight);
    };
  
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const handleGroupChange = (event, val) => {
    if (event.target.value && errorGroup) {
      setErrorGroup(null);
    }

    setCheckValue(false);
    const containsAllProperty = val.some(obj => obj.hasOwnProperty('all'));

    if (clientGroupList.length === activeGroups.length && containsAllProperty) {
      setGroupCheckValue(false);
      setActiveGroups([]);
      setCheckValue(false);
      setActiveCameras([]);
      setCamerasByGroup([]);
    } else if (containsAllProperty) {
      setGroupCheckValue(true);
      let groupId = clientGroupList.map(val => val.GroupId);
      setActiveGroups(groupId);
    } else {
      const grpId = val[0].GroupId;
      const avail = activeGroups.length > 0 ? activeGroups.filter(item => item === grpId) : [];

      if (avail.length > 0) {
        const id = activeGroups.filter(item => item !== grpId);
        setActiveGroups(id);
        setGroupCheckValue(false);

        if (id.length === 0) {
          setCheckValue(false);
          setActiveCameras([]);
          setCamerasByGroup([]);
        }
      } else {
        setActiveGroups((id) => [...id, grpId]);
      }
    }
  };


  const handleCameraChange = (event, newValue) => {
    setSelectedCameras(newValue);
  };

  const handleGridLayout = () => {
    if (activeCameras.length === 1 || activeCameras.length === 2 || activeCameras.length === 3) {
      setGridLayout({ xs: 3 });
    } else {
      const numRows = Math.ceil(activeCameras.length / 4);
      const numCols = Math.min(4, activeCameras.length);
      setGridLayout({
        xs: 12 / numCols,
        style: { gridColumnEnd: `span ${numRows}` },
      });
    }
  };

  const handleSubmit = () => {

    setSaveError(false);
    setErrorGroup(null);
    if (!isClient && selectedClient === '') {
      setSaveError(true);
      return;
    }

    if (clientGroupList.length > 0 && activeGroups.length === 0) {
      setErrorGroup({ message: 'Select Group' });
      return;
    }

    setLiveCamerasList([]);
    if (activeCameras.length === 0) {
      setErrorMessage('Please Select Atleast One Camera');
      return;
    } else {
      setErrorMessage('');
      getCamerasList_Live(activeCameras, (response) => {
        if (response.status === 200) {
          setLiveCamerasList(response.data);
          setIsInitialLoad(true);
          setSubmitted(true);
          setOpenAuto(false);
        }
      });
    }
  };

  const handleClear = () => {
    setLiveCamerasList([]);
    setSelectedCameras([]);
    setSelectedGroup("");
    setCamerasByGroup([]);
    setSubmitted(false);
    setActiveCameras([]);
    setOpenAuto(false);
    setInputValue([]);
    setCheckValue(false);
    setClient('');
    setSelectedClient(null);
    setClientLocationOptions([]);
    setSelectedClientLocations([]);
    setLocationCheckValue(false);
    hasTriggeredSubmit.current = false;
  };

  const getGridLayout = () => {
    if (!submitted || selectedCameras.length === 0) {
      return { xs: 12 };
    } else {
      if (selectedCameras.length === 1) {
        return { xs: 12 };
      } else if (selectedCameras.length === 2 || selectedCameras.length === 3) {
        return { xs: 6 };
      } else {
        const numRows = Math.ceil(selectedCameras.length / 4);
        const numCols = Math.min(4, selectedCameras.length);
        const rowSpan = selectedCameras.length === 1 ? numRows : 1;
        return {
          xs: 12 / numCols,
          style: { gridColumnEnd: `span ${rowSpan}` },
        };
      }
    }
  };

  const handleLiveCamera = (event, newValue) => {
    
    console.log("Live camerasa",newValue);
    setSelectedCameras(newValue);
    if ((!newValue || newValue.length === 0) && liveCamerasList.length === 0) {

    // if (!newValue || newValue.length === 0 ||liveCamerasList.length === 0) {
      setLiveCamerasList([]);
    }

    let lengthofCameras = clientGroupList.length ? camerasByGroupId.length : (client_id == "1316") ?  filteredCamerawithoutGroups.length : camerawithoutGroups.length;
    let cameraValues = clientGroupList.length ? camerasByGroupId : (client_id == "1316") ?  filteredCamerawithoutGroups : camerawithoutGroups;

    if (newValue.some(obj => obj.hasOwnProperty('all'))) {
      if ((newValue[0].all && newValue.length !== 2) || (newValue[newValue.length - 1].all)) {
        // setOpenAuto(false);
      } else {
        // setOpenAuto(true);
      }
    } else {
      if (newValue.length === lengthofCameras) {
        // setOpenAuto(false);
      } else {
        // setOpenAuto(true);
      }
    }

    if (newValue.length > 1 && newValue.every((entry, index, arr) => JSON.stringify(entry) === JSON.stringify(arr[0]))) {
      newValue = [];
    }

    const containsAllProperty = newValue.some(obj => obj.hasOwnProperty('all'));

    if (containsAllProperty) {
      if (newValue.length === 1) {
        setSelectedCameras(cameraValues);
      } else {
        let val = newValue.filter(item => !item.all);
        setSelectedCameras(val);
      }
    }

    if (newValue.length === 0 || !containsAllProperty) {
      setCheckValue(false);
    }

    let actCameras = [];

    if (newValue.length > 0 && !containsAllProperty) {
      newValue.forEach((row) => {
        clientGroupList.length ? actCameras.push(row.deviceid) : actCameras.push(row.deviceid);
      });

      if (lengthofCameras === actCameras.length) {
        setCheckValue(true);
        // setOpenAuto(false);
      }

      setActiveCameras([...actCameras]);
      setInputValue([...newValue]);
    }

    if (newValue.length > 0 && containsAllProperty) {
      let Cameras = cameraValues;
      actCameras = [];

      if (activeCameras && activeCameras.length === lengthofCameras) {
        setCheckValue(false);
        let deviceIds = [];

          deviceIds = newValue.filter(obj => !obj.hasOwnProperty('all')).map(obj => obj.deviceid);
          Cameras = Cameras.filter(item => !deviceIds.includes(item.deviceid));
          Cameras.forEach((row) => {
            actCameras.push(row.deviceid);
          });

        if (clientGroupList.length) {
          setInputValue(camerasByGroupId);
        } else if (client_id === "1316") {
          setInputValue(filteredCamerawithoutGroups);
        } else {
          setInputValue(camerawithoutGroups);
        }

        setActiveCameras([...actCameras]);
        // setOpenAuto(false);
        return;
      }

      if (!checkValue) {

        Cameras.forEach((row) => {
          actCameras.push(row.deviceid);
        });
        setActiveCameras([...actCameras]);
        

        if (clientGroupList.length) {
          setInputValue(camerasByGroupId);
        } else if(client_id === "1316") {
          setInputValue(filteredCamerawithoutGroups);
        } else {
          setInputValue(camerawithoutGroups);
        }

        setCheckValue(true);

      } else {
        setActiveCameras([]);
        setInputValue([]);
      }
    } else if (newValue.length === 0) {
      setActiveCameras([]);
      setCheckValue(false);
      setInputValue([]);
      // setOpenAuto(true);
    }
  };
 

  const showFilter = () => {
    setShowGrid(!showGrid);
  };

 
  const handleFilterOptions = (options, params) => {
    const filter = createFilterOptions();
    const filtered = filter(options, params);

    const selectedOptions = filtered.filter(option => activeCameras.includes(option.deviceid));
    const unselectedOptions = filtered.filter(option => !activeCameras.includes(option.deviceid));

    const sortedOptions = [...selectedOptions, ...unselectedOptions];
    return [{ title: 'Select All', all: true }, ...filtered];
  };

  const handleGroupFilterOptions = (options, params) => {
    const filter = createFilterOptions();
    const filtered = filter(options, params);
    return [{ title: 'Select All', all: true }, ...filtered];
  };

  const isValidUrl = (url) => {
    try {
      const parsed = new URL(url);
      return parsed.protocol === "http:" || parsed.protocol === "https:";
    } catch (err) {
      return false;
    }
  };

  const generateIframeSrc = (camera) => {
    const url =
      camera.LiveUrl && camera.LiveUrl !== 'null'
        ? camera.LiveUrl
        : generateStreamURL(camera.substream);
  
    return isValidUrl(url) ? url : null;
  };

  // const generateIframeSrc = (camera) => {
  //   let frameUrl = '';
  
  //   if (camera.LiveUrl !== null && camera.LiveUrl && camera.LiveUrl !== 'null') {
  //     if (isValidUrl(camera.LiveUrl)) {
  //       frameUrl = camera.LiveUrl;
  //     }
  //   } else {
  //     const streamUrl = generateStreamURL(camera.substream);
  //     if (isValidUrl(streamUrl)) {
  //       frameUrl = streamUrl;
  //     }
  //   }
  
  //   return frameUrl;
  // };


  const handleClientType = (event) => {
    setClientType(event.target.value);
    setClientTypeError('');
  };

  return (
    <Page title="Live">
      <Container maxWidth="xxl" sx={{p:0}}>
        <Box sx={{ mb: 3 }}>
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4">Live</Typography>
          </Box>
          {userType=='2' && (<Breadcrumbs separator="•" aria-label="breadcrumb">
            <DashboardBreadcrumbLink sx={{ fontSize: '0.875rem' }} />
            <Typography color="text.secondary" sx={{ fontSize: '0.875rem' }}>Live</Typography>
          </Breadcrumbs>)}
        </Box>
        <Box>          

          {!showGrid && (
            <Grid
              container
              spacing={1}
              sx={{
                display: showOptions ? "flex" : "none",
                p: 2,
                mb: 2,
                backgroundColor: UI.cardBg,
                border: `1px solid ${UI.cardBorder}`,
                borderRadius: 3,
                boxShadow: UI.shadow,
              }}
            >
            <Grid container spacing={2}>

              {client_id === "1316" && locations.length > 1 &&
                <Grid item xs={12} sm={6} md={3}>
                  <FormControl fullWidth>
                    <InputLabel>Location</InputLabel>
                    <Select
                      value={location || ''}
                      size="small"
                      label="Location"
                      onChange={(e) => {
                        const val = e.target.value;
                        localStorage.setItem('selectedLocation', val);
                        changeLocation(val);
                      }}
                    >
                      {locations.map((event) => (
                        <MenuItem key={event.Id} value={event.Id}>
                          {event.LocationName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              }

              {properties.length > 1 &&
                <Grid item xs={12} sm={6} md={3}>
                  <FormControl fullWidth>
                    <InputLabel>Location</InputLabel>
                    <Select
                      value={property || ''}
                      size="small"
                      label="Location"
                      onChange={(e) => {
                        const val = e.target.value;
                        localStorage.setItem('selectedProperty', val);
                        changeProperty(val);
                      }}
                    >
                      {properties.map((event) => (
                        <MenuItem key={event.ID} value={event.ID}>
                          {event.Location}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              }

              {!isClient && !isReseller && (
                <Grid item xs={12} sm={6} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="client-type-label">Client Type</InputLabel>
                    <Select
                      labelId="client-type-label"
                      id="client-type"
                      value={clientType}
                      size="small"
                      label="Client Type"
                      onChange={handleClientType}
                    >
                      <MenuItem value="US">US</MenuItem>
                      <MenuItem value="INDIA">INDIA</MenuItem>
                    </Select>
                    {clientTypeerror && (
                      <Typography variant="body2" color="error">{clientTypeerror}</Typography>
                    )}
                  </FormControl>

                </Grid>
              )}

              {!isClient && (
                <Grid item xs={3}>
                  <FormControl fullWidth>
                    <Autocomplete
                      fullWidth
                      size="small"
                      id="tags-outlined"
                      options={uniqueClientOptions.map((clientItem, clientIndex) => ({
                        ...clientItem,
                        customKey: `${clientItem.ID || clientItem.id}-${clientIndex}`,
                      }))}
                      isOptionEqualToValue={(option, value) => option.ID === value.ID}
                      getOptionLabel={(option) =>  `${option.displayname || ''}`}
                      onChange={(event, val) => {
                        setSelectedClient(val);
                        handleClient(event, val);
                      }}
                      value={selectedClient}
                      filterSelectedOptions
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          label="Clients"
                          placeholder="Enter Client Name"
                        />
                      )}
                      renderOption={(props, option) => (
                        <li {...props} key={option.customKey}>
                          {option.displayname}
                        </li>
                      )}
                    />
                    {(saveError) && (
                      <Typography variant="body2" color="error">Please select a client.</Typography>
                    )}
                  </FormControl>
                </Grid>
              )}

              {selectedClient && clientLocationOptions.length > 1 && (
                <Grid item xs={3}>
                  <Autocomplete
                    multiple
                    id="tags-outlined-locations"
                    options={clientLocationOptions}
                    onChange={handleClientLocationChange}
                    value={clientLocationOptions.filter((locationItem) =>
                      selectedClientLocations.includes(locationItem.ID || locationItem.id)
                    )}
                    disableCloseOnSelect
                    filterOptions={handleLocationFilterOptions}
                    getOptionLabel={(option) => option.selectall ? option.title : `${option.Location || ''}`}
                    renderTags={() => null}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        label="Select Locations"
                        placeholder="Search Location..."
                      />
                    )}
                    renderOption={(props, option) => {
                      if (option.selectall) {
                        return (
                          <li {...props} key="select-all-locations">
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={locationCheckValue}
                              disabled={clientLocationOptions.length === 0}
                            />
                            {option.title}
                          </li>
                        );
                      }

                      return (
                        <li {...props} key={option.ID || option.id}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selectedClientLocations.includes(option.ID || option.id)}
                          />
                          {option.Location}
                        </li>
                      );
                    }}
                  />
                </Grid>
              )}

              {(clientGroupList.length > 0) && (
                <Grid item xs={3}>
                  <Autocomplete
                    multiple
                    id="tags-outlined-groups"
                    options={clientGroupList}
                    onChange={handleGroupChange}
                    value={[]}
                    disableCloseOnSelect
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        label="Select Groups"
                        placeholder="Search Group Name..."
                      />
                    )}
                    filterOptions={handleGroupFilterOptions}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        {option.all ? (
                          <>
                            <Checkbox
                              icon={groupicon}
                              checkedIcon={groupcheckedIcon}
                              style={{ marginRight: 8 }}
                              checked={groupCheckValue}
                            />
                            {option.title}
                          </>
                        ) : (
                          <>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={activeGroups.includes(option.GroupId)}
                              onChange={() => {
                                const isChecked = activeGroups.includes(option.GroupId);
                                const newActiveGroups = isChecked
                                  ? activeGroups.filter((groupId) => groupId !== option.GroupId)
                                  : [...activeGroups, option.GroupId];
                                setActiveGroups(newActiveGroups);
                              }}
                            />
                            {`${option.GroupName}`}
                          </>
                        )}
                      </li>
                    )}
                    isOptionEqualToValue={(option, value) => option.GroupId === value.GroupId}
                  />
                  {errorGroup && (
                    <Typography color="error" variant="body2" align="center">{errorGroup.message}</Typography>
                  )}
                </Grid>
              )}

              <Grid item xs={(clientGroupList.length > 0 || !isClient) ? 3 : (client_id === "1316") ? 3 : 5}>
                <Autocomplete
                  multiple
                  id="tags-outlined-cameras"
                  options={clientGroupList.length > 0 ? camerasByGroupId : (client_id === "1316") ? filteredCamerawithoutGroups : camerawithoutGroups}
                  getOptionLabel={(option) => {
                    if (!option || typeof option !== 'object') return "";
                    if (option.all) return option.title || "Select All";
                    return option.devicename || "";
                  }}
                  onChange={handleLiveCamera}
                  disableCloseOnSelect
                  filterOptions={handleFilterOptions}
                  onInputChange={(event, newInputValue) => {
                    if (!newInputValue) setLiveCamerasList([]);
                  }}
                  value={
                    checkValue
                      ? [{ title: 'Select All', all: true }]
                      : inputValue.filter((camera) =>
                          clientGroupList.length
                            ? activeCameras.includes(camera.deviceid)
                            : activeCameras.includes(camera.deviceid)
                        )
                  }
                  renderTags={() => null}
                  clearOnBlur={true}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      height: 40,
                      backgroundColor: UI.inputBg,
                      color: UI.inputText,
                    },
                    '& .MuiInputLabel-root': {
                      color: UI.inputMuted,
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: UI.border,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: UI.borderHover,
                    },
                    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      label="Select Camera"
                      placeholder="Search by Camera Name..."
                      InputLabelProps={{ style: { color: UI.inputMuted } }}
                    />
                  )}
                  ListboxProps={{
                    sx: {
                      bgcolor: 'background.paper',
                      color: 'text.primary',
                    },
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      {(!clientGroupList.length || activeGroups) && option.all ? (
                        <>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8, color: theme.palette.primary.main }}
                            checked={checkValue}
                            onChange={() => setCheckValue(!checkValue)}
                          />
                          {option.title}
                        </>
                      ) : option.deviceid && activeGroups.length === 0 ? (
                        <>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8, color: theme.palette.primary.main }}
                            checked={activeCameras.includes(option.deviceid)}
                            onChange={() => {
                              const isChecked = activeCameras.includes(option.deviceid);
                              const newActiveCameras = isChecked
                                ? activeCameras.filter((id) => id !== option.deviceid)
                                : [...activeCameras, option.deviceid];
                              setActiveCameras(newActiveCameras);
                            }}
                          />
                          {option.devicename}
                        </>
                      ) : activeGroups.length > 0 && (
                        <>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8, color: theme.palette.primary.main }}
                            checked={activeCameras.includes(option.deviceid)}
                            onChange={() => {
                              const isChecked = activeCameras.includes(option.deviceid);
                              const newActiveCameras = isChecked
                                ? activeCameras.filter((id) => id !== option.deviceid)
                                : [...activeCameras, option.deviceid];
                              setActiveCameras(newActiveCameras);
                            }}
                          />
                          {option.devicename}
                        </>
                      )}
                    </li>
                  )}
                />
                {errorMessage && (
                  <Typography color="error" variant="body2" align="center">
                    {errorMessage}
                  </Typography>
                )}
              </Grid>


              <Grid item xs={2} sx={{ display: 'flex', alignItems: 'center' }}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <LoadingButton variant="contained" onClick={handleSubmit} sx={{ height: 40, minWidth: 96 }}>
                    Submit
                  </LoadingButton>
                  <LoadingButton
                    variant="contained"
                    color="error"
                    onClick={handleClear}
                    sx={{ height: 40, minWidth: 96 }}
                  >
                    Cancel
                  </LoadingButton>
                </Stack>
              </Grid>
            </Grid>
            </Grid>
          )}

          <Grid
            sx={{
              backgroundColor: (theme) => theme.palette.background.default,
              padding: 0,
              minHeight: '50px',
            }}
            container
            spacing={1}
          >
          {submitted && liveCamerasList.length > 0 && (
            <Grid container spacing={0} mt={0} px={0} mb={0}>
              {liveCamerasList.map((camera, index) => {
                const iframeSrc = generateIframeSrc(camera);

	                return (
	                  <Grid item xs={xsCount} key={index}>
	                    <Typography
	                      variant="caption"
	                      noWrap
	                      sx={{
	                        display: 'inline-flex',
	                        alignItems: 'center',
	                        mb: 0,
	                        px: 1,
	                        py: 0.35,
	                        borderTopLeftRadius: 4,
	                        borderTopRightRadius: 4,
	                        borderLeft: `1px solid ${UI.cardBorder}`,
	                        borderRight: `1px solid ${UI.cardBorder}`,
	                        borderTop: `1px solid ${UI.cardBorder}`,
	                        background: UI.cardBg,
	                        color: UI.inputText,
	                        fontSize: '14px',
	                        fontWeight: 500,
	                        lineHeight: 1.2,
	                        maxWidth: '100%',
	                      }}
	                    >
	                      {camera.devicename}
	                    </Typography>
	                    <Card
	                      sx={{
	                        background: UI.cardBg,
	                        border: `1px solid ${UI.cardBorder}`,
	                        boxShadow: UI.shadow,
	                        borderRadius: 1,
	                        padding: 0,
	                        height: outerBoxHeight,
	                        display: 'flex',
	                        flexDirection: 'column',
	                        justifyContent: 'space-between',
	                        overflow: 'hidden',
	                        color: UI.inputText
	                      }}
	                    >

	                      <Box
	                        sx={{
	                          position: 'relative',
	                          width: '100%',
	                          height: cameHeight,
	                        }}
                      >
                        {iframeSrc ? (
                          <iframe
                            src={iframeSrc}
                            allowFullScreen
                            style={{
                              width: '100%',
                              height: '100%',
                              border: 'none',
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              width: '100%',
                              height: '100%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              background: UI.cardBg,
                              color: UI.inputMuted,
                              fontSize: '16px',
                              fontWeight: '500'
                            }}
	                          >
	                            Stream Not Found
	                          </div>
	                        )}
	                      </Box>
	                    </Card>
	                  </Grid>
                )
              })}
            </Grid>
          )}

          </Grid>
        </Box>

        <Fab
          color="primary"
          aria-label={showGrid ? "show-filters" : "hide-filters"}
          onClick={showFilter}
          sx={{
            position: 'fixed',
            bottom: 24,
            right: 24,
            zIndex: (theme) => theme.zIndex.drawer + 2,
          }}
        >
          {showGrid ? <FilterAltIcon /> : <FilterAltOffIcon />}
        </Fab>
      </Container>
    </Page>
  );
}


